// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c05a6442","703":"da60ed5b"}[chunkId] + ".chunk.js";
};